import { getPlaceImage, isPlaceOpenToday } from '@/helpers';
import { _s, __ } from '@/locale';
import { FILTER_ID } from '@/types/state/search';
import { Place } from '@/types/state/shared';
import moment from 'moment';

export const mapOtherPlaces = (places: Place[], currentPlaceId: number) => {
  const firstThreePlaces = places.filter((place) => place.id !== currentPlaceId).slice(0, 3);

  return firstThreePlaces.map((place) => {
    const imagePreview = getPlaceImage(place);
    const openHours = isPlaceOpenToday(place);

    return {
      id: place.id,
      to: `/places/${place.about?.slug}-${place.id}`,
      name: place.about?.name,
      address: { street: place.contact?.address?.street, city: place.contact?.address?.city },
      rating: place.rating?.score,
      image: imagePreview,
      openHours,
    };
  });
};

export const getCompanyWebsiteWithProcotol = (place: Place) => {
  let url = (place.contact?.website || '').trim();
  if (url && url.indexOf(' ') === -1 && url.indexOf('http') === -1) {
    url = 'https://' + url;
  }
  return url;
};

export const getMatchedServicesTitle = ({
  q,
  startDate,
  endDate,
  timeOfDay,
  prefs,
}: {
  q: string;
  startDate: string;
  endDate: string;
  timeOfDay: string;
  prefs: string;
}) => {
  let label = q;

  if (prefs && prefs.indexOf(FILTER_ID.toString()) !== -1) {
    label += `- ${_s(`wellnesscard`)}`;
  }

  if (startDate && endDate) {
    const startDateObject = moment.utc(startDate);
    const endDateObject = moment.utc(endDate);
    const startDateMonthLabel = __(startDateObject.format('MMM'));
    const endDateMonthLabel = __(endDateObject.format('MMM'));
    const isSameMonth = startDateMonthLabel === endDateMonthLabel;
    const startDateLabel = `${startDateObject.format('D')}${isSameMonth ? '' : ` ${startDateMonthLabel}`}`;
    const endDateLabel = `${endDateObject.format('D')} ${endDateMonthLabel}, ${endDateObject.format('YYYY')}`;
    label += `, ${startDateLabel} - ${endDateLabel}`;

    if (timeOfDay) {
      label += `, ${__(`timeOfDay_${timeOfDay}`)}`;
    }
  }

  return label;
};
